module.exports = __webpack_public_path__ + "cf0bf9d2.png";